import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, ModalBody, NavLink  } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { redirectToCancelUrl, getMerchantData } from 'actions/payment';

const redirectToRetryUrl = () => {
    const { SessionToken, ConfigId } = getMerchantData()
    const retryURL = `?sessionToken=${SessionToken}&configId=${ConfigId}`
    window.location = retryURL
}

const GlobalError = props => {

    if(props.errorMessage){
        return (
            <ModalBody>
                <div  role="group">
                    <span className="icon-warning-square font50 text-center"></span>
                    <p className="text-14 text-center">{props.errorMessage}</p>
                    <div className="col text-center">
                    <Button onClick={redirectToRetryUrl}>{props.t('retry_payment')}</Button>
                    </div>
                    
                </div>
            {/* <div >
            <span className="icon-warning-square font50 text-center"></span>
                <p className="text-14 text-center">vdfgd{props.errorMessage}</p>
                <Button onClick={redirectToRetryUrl}>{props.t('retry_payment')}</Button>
            </div> */}
         </ModalBody>
        )
    }
    // console.log("ERRORCODE",props.errorCode)
    else if(props.errorCode === "FPDR4025"){
        return (
            <ModalBody>
            <div >
            <span className="icon-warning-square font50 text-center"></span>
                <p className="text-14 text-center">{props.t('glob_pop_content3')}</p>
    
            </div>
         </ModalBody>
        )
    }else{
        return (
            <ModalBody>
                <div className="text-center mb-3">
                    <span className="icon-warning-square font50"></span>
                    <p className="text-14">{props.t('glob_pop_content1')}</p>
                    { props.retryBtn && <p className="text-14">{props.t('retry_with_other')}</p> }
                    { 
                        props.from!=='fromBankRetry' && 
                        <p className="text-14 mt-2">{props.t('glob_pop_content2')}</p>
                    }
                </div>
                {
                    props.retryBtn && (
                        <>
                            <div className="d-flex mt-4" role="group">
                                <NavLink className="link-16 ml-4" href="#" onClick={redirectToCancelUrl}>{props.t('cancel_payment')}</NavLink>
                                <Button onClick={redirectToRetryUrl}>{props.t('retry_payment')}</Button>
                            </div>
                            <div className="goBack">
                                <p>{props.t('cancel_payment_back_to')}<NavLink> {props.t('merchant_site')}</NavLink></p>
                            </div>
                        </>
                    )
                }
                
            </ModalBody>
        )
    }

}

export default withTranslation('translations')(modalWrapper(true, "GlobalErrorModal")(GlobalError));